import { render, staticRenderFns } from "./shareOrder2.vue?vue&type=template&id=5424abd8&scoped=true&"
import script from "./shareOrder2.vue?vue&type=script&lang=js&"
export * from "./shareOrder2.vue?vue&type=script&lang=js&"
import style0 from "./shareOrder2.vue?vue&type=style&index=0&id=5424abd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424abd8",
  null
  
)

export default component.exports